import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';
import ISelect from 'CMPT/common/Select';
import Table from 'CMPT/common/Table';
import http from '@/http';
import { API } from '@/http/api';
import { AUTH_KEYS } from '@/utils/auth';
import AuthContainer from 'CMPT/common/auth/AuthContainer';
import { Input, Row, Col, DatePicker, Icon, Select, Spin, message, Modal } from 'antd';
import user from '@/utils/user'
import "./finance.less"
// import FinanceApproval from './temp';
const { isManager } = user;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const { TextArea } = Input;

const feeTypeList = ['定金', '保证金', '合同保证金', '装修保证金', '物业保证金', '租金', '手续费', '服务费', '保洁费', '物业费', '网费', '水费', '电费', '滞纳金', '违约金', '搬家费', '耗材费', '其他费用'];
const billTypeList = ['合同', '运营'];
const success = () => {
    message.success('催缴成功，我们将以短信形式通知付款人');
};
const info = () => {
    message.info('每小时只能催缴一次，请稍候再试');
};
class FinanceApproval extends Component {
    state = {
        billInfo: {},
        showReceiptModal: false,
        showRefundModal: false,
        countData: {
            all: 0,
            audited: 0,
            toAudit: 0
        },
        fetching: false,
        dateValue: [],
        currentIndex: 0,
        dateType: [{
            name: '应收付时间',
            value: 1
        },
        {
            name: '创建时间',
            value: 6
        }],
        payChannel: [{
            name: '现金',
            value: 1
        }, {
            name: '刷卡',
            value: 2
        }, {
            name: '转账',
            value: 3
        }, {
            name: '支付宝',
            value: 4
        }, {
            name: '微信',
            value: 5
        }, {
            name: '其他',
            value: 9
        }],
        projects: [],
        fetchingprojects: true,
        man: [],
        bill: [
            { value: 1, name: '合同' },
            { value: 2, name: '运营' }
        ],
        pay: [
            { value: 1, name: '收款' },
            { value: 2, name: '付款' }
        ],//1 已结清 2代收款 3一笔收款驳回 4一笔收款审批中
        auditStatusList: [
            { value: 0, name: '审批中' },
            { value: 1, name: '审批驳回' },
            { value: 2, name: '审批通过' }
        ],
        columns: [
            {
                title: '区域名称',
                dataIndex: 'floorMsg',
            }, {
                title: '账单/费用类型',
                key: 'billType',
                render(obj) {
                    return (
                        <div>
                            <span className="bill-type" style={{ background: obj.billType == 1 ? '#434BA3' : "#B76C1E" }}>{billTypeList[obj.billType - 1]}</span>
                            <span className="fee-type">{obj.feeType == 99 ? '其他费用' : feeTypeList[obj.feeType - 1]}</span>
                        </div>
                    )
                }
            }, {
                title: '收付类型',
                dataIndex: 'budgetType',
                render(value) {
                    console.log(value)
                    const budgetTypeList = ['收款', '付款'];
                    return (
                        <div>{budgetTypeList[value - 1]}</div>
                    )
                }
            }, {
                title: '应收付金额(元)',
                dataIndex: 'payAmount'
            }, {
                title: '应收付时间',
                dataIndex: 'payDate',
                sorter: true
            }, {
                title: '费用周期/期数',
                render(value) {
                    if (value.beginDate && value.endDate) {
                        return (
                            <div>{value.beginDate}至{value.endDate}</div>
                        )
                    } else {
                        return '-'
                    }

                }

            }, {
                title: '收付款人',
                key: 'customerName',
                width: 200,
                render: (obj) => {
                    return (
                        <div>
                            <div>{obj.customerName}</div>
                            <div>{obj.customerPhone}</div>
                        </div>
                    )
                }
            }, {
                title: '审批状态',
                dataIndex: 'auditStatus',
                width: 200,
                render(value) {
                    const auditStatusList = ['审批中', '审批驳回', '审批通过'];
                    let color = ''
                    switch (value) { // 0 待审批，1 已驳回 2 通过 3 不通过
                        case 0:
                            color = '#FBBC06'
                            break
                        case 1:
                            color = '#E94437'
                            break;
                        case 3:
                            color = '#EE423D'
                            break
                        default:
                            color = '#E94437'
                    }
                    return (
                        <div><span style={{ color: color, marginRight: '6px' }}>●</span>{auditStatusList[value]}</div>
                    )
                }

            }, {
                title: '创建时间',
                dataIndex: 'createTime',
                sorter: true
            }, {
                title: '审批人',
                dataIndex: 'auditUserName',
                render: (value) => {
                    return (
                        <div style={{ width: '110px' }} className="textShen">
                            <span>{value ? value : '-'}</span>
                        </div>
                    )
                }
            }, {
                title: '操作',
                fixed: 'right',
                render: (value) => {
                    return (
                        <div>
                            <AuthContainer authCodes={AUTH_KEYS.OPERATE_FINANCE_BILL_AUDIT_VIEW}>
                                <Link to={'/app/operate/finance/approval/detail/' + value.encode} className="table-operate-btn">详情</Link>
                            </AuthContainer>
                            <Link to={'/app/operate/finance/approval/action/' + value.encode} className="table-operate-btn" style={{ display: value.audit ? '' : 'none' }}>审批</Link>
                        </div>
                    )
                }
            }
        ],
        data: [],
        queryParams: {
            pageNo: 1,
            pageSize: 10,
            keyword: undefined, // 搜索关键字
            projectEncodes: [], //项目id
            feeTypes: [], //费用类型
            auditStatus: undefined, //审核状态
            billType: undefined, // 账单类型
            budgetType: undefined, // 收付类型
            endDate: undefined,
            beginDate: undefined,
            dateType: undefined,
            auditFilterType: 0,
            channel: undefined, //支付途径
            auditUserEncode: undefined, //审批人
            orderByList: [2]
            // budgetType:1, //收款
        },
        popAmount: '',
        tuiAmount: '',
        tuiReason: '',
    }
    componentDidMount(props) {
        this.getProjectList();
        const search = this.props.location.search
        if (search) {
            const formatData = this.formatSearch(search);
            if (formatData.type == 1) {
                this.changetab(1);
                this.getAuditCount();
                return;
            }
        }
        this.getList(true)
        if (isManager()) {
            this.getCustomerList();
        }
    }
    componentWillReceiveProps(props, value) {
        console.log(props, value)
    }
    formatSearch = (ss) => {
        const ssSplit = ss.split('?')[1].split('&')
        let obj = {}
        ssSplit.forEach(per => {
            let perSplit = per.split('=')
            obj[perSplit[0]] = perSplit[1]
        })
        return obj
    }
    changePopAmountValue(key, value) {
        let data = this.state
        data[key] = value.target.value;
        this.setState(data)
    }
    receipt(value) {
        // console.log(value);
        this.setState({ showReceiptModal: true, billInfo: value })
    }
    receiptOk() {
        http({
            api: API.billReceipt,
            data: {
                billEncode: this.state.billInfo.encode,
                amount: this.state.popAmount
            }
        }).then(res => {
            if (res.data) {
                console.log("loadCaptcha--------------", res.data);
            }
        })
    }
    receiptCancel() {
        this.setState({ showReceiptModal: false })
    }
    refund(value) {
        this.setState({ showRefundModal: true, billInfo: value })
    }
    refundOk() {
        http({
            api: API.billrefundRefund,
            data: {
                billEncode: this.state.billInfo.encode,
                amount: this.state.tuiAmount,
                reason: this.state.tuiReason,
                refundEncode: ''
            }
        }).then(res => {
            if (res.data) {
                console.log("loadCaptcha--------------", res.data.datas);
            }
        })
    }
    refundCancel() {
        this.setState({ showRefundModal: false })
    }
    getAuditCount() {
        http({
            api: API.billAuditCount,
            data: this.state.queryParams
        }).then(res => {
            if (res.data) {
                console.log("loadCaptcha--------------", res.data);
                this.setState({
                    countData: res.data
                })
            }
        })
    }
    callPill(value) {
        console.log(value);
        http({
            api: API.billRemind,
            data: {
                billEncode: value
            }
        }).then(res => {
            if (res.data) {
                // console.log("loadCaptcha--------------", res.data.success);
                if (res.data.success == 1) {
                    success();
                }
                if (res.data.success == 0) {
                    info();
                }
            }
        })
    }
    getList = (value) => {
        http({
            api: API.billAuditList,
            data: this.state.queryParams
        }).then(res => {
            if (res.data) {
                // console.log("loadCaptcha--------------", res.data.datas);
                let tempData = this.state.queryParams;
                tempData.total = res.data.total;
                tempData.pageNo = res.data.pageNo;
                tempData.pageSize = res.data.pageSize;
                this.setState({
                    data: res.data.datas,
                    queryParams: tempData
                })
            }
        })
        if (value) {
            this.getAuditCount();
        }
    }
    keyWordSearch = (value) => {
        let queryParams = this.state.queryParams
        queryParams.pageNo = 1
        queryParams.keyword = value
        this.setState({
            queryParams
        })
        this.getList(true)
    }
    selectChange = (attr, data) => {
        // console.log('+++++++++')
        // console.log(attr,data);
        let queryParams = this.state.queryParams
        queryParams.pageNo = 1
        queryParams[attr] = data
        this.setState({ queryParams })
        this.getList(true)
    }
    resetParams = () => {
        let data = Object.assign({}, this.state.queryParams, {
            pageNo: 1,
            pageSize: 10,
            keyword: undefined, // 搜索关键字
            projectEncodes: [], //项目id
            feeTypes: [], //费用类型
            auditStatus: undefined, //审核状态
            billType: undefined, // 账单类型
            budgetType: undefined, // 收付类型
            endDate: undefined,
            beginDate: undefined,
            dateType: undefined,
            auditFilterType: 0,
            auditUserEncode: undefined,
            channel: undefined,
            orderByList: [2]
        });
        this.setState({ queryParams: data, dateValue: [] }, () => {
            this.getList(true);
        });
    }
    setKeyWord = (e) => {
        let data = Object.assign({}, this.state.queryParams, { keyword: e.target.value });
        this.setState({ queryParams: data });
    }
    onChange = (pageNo, pageSize, sort) => {
        console.log(sort)
        let queryParams = this.state.queryParams
        if (sort) {
            if (sort.columnKey == "payDate") {
                if (sort.order == "ascend") {
                    queryParams.orderByList = [15]
                }
                if (sort.order == "descend") {
                    queryParams.orderByList = [16]
                }
            }
            if (sort.columnKey == "createTime") {
                if (sort.order == "ascend") {
                    queryParams.orderByList = [1]
                }
                if (sort.order == "descend") {
                    queryParams.orderByList = [2]
                }
            }
        }

        queryParams.pageNo = pageNo
        queryParams.pageSize = pageSize
        this.setState({ queryParams })
        this.getList()
    }
    //选择处理时间类型
    choosedateType(e) {
        let data = Object.assign({}, this.state.queryParams, { dateType: e, pageNo: 1, pageSize: 10 })
        this.setState({ queryParams: data }, () => {
            if (this.state.queryParams.dateType && this.state.queryParams.beginDate && this.state.queryParams.endDate) {
                this.getList(true);
            }
        });
    }
    //改变上报时间
    onChangedate(date, options) {
        console.log(date);
        let data = Object.assign({}, this.state.queryParams, { beginDate: options[0], endDate: options[1], pageNo: 1, pageSize: 10 })
        this.setState({ queryParams: data, dateValue: date }, () => {
            if (this.state.queryParams.dateType && this.state.queryParams.beginDate && this.state.queryParams.endDate) {
                this.getList(true);
            }
            if (this.state.queryParams.beginDate == '' && this.state.queryParams.endDate == '') {
                this.getList(true);
            }
        });

    }
    changetab(value) {//修改tab
        let data = Object.assign({}, this.state.queryParams, { auditFilterType: value, pageNo: 1 });
        this.setState({ queryParams: data }, () => {
            this.getList();
        });
    }
    getProjectList() {
        http({
            api: API.commonProjectfilter,
        }).then(res => {
            console.log("loadCaptcha--------------", res.data);
            this.setState({
                projects: res.data,
                fetchingprojects: false
            })
        })
    }
    getCustomerList(value) {
        console.log(value)
        http({
            api: API.userGetList,
            data: {
                nameLike: value,
                pageSize: null
            }
        }).then(res => {
            console.log(res);
            this.setState({
                man: res.data.datas
            })
        })
    }
    handleChange(value) {
        this.setState({
            fetching: false,
        }, () => { this.getList(true) });
    }

    notFount() {
        return (
            <div style={{ textAlign: 'center', height: '100px', lineHeight: '100px' }}>加载中...</div>
        )
    }
    notFoundContent() {
        return (
            <div className='ant-empty ant-empty-normal ant-empty-small'><div className="ant-empty-image"></div><p className="ant-empty-description">暂无数据</p></div>)
    }
    render() {
        const { queryParams: params, fetching, countData, billInfo, fetchingprojects } = this.state;
        const options = this.state.projects && this.state.projects.map(per => {
            return <Option value={per.encode} key={per.encode}>{per.name}</Option>
        })
        const optionsFee = feeTypeList.map((per, index) => {
            if (per == '其他费用') {
                return <Option value={99} key={99}>{per}</Option>
            } else {
                return <Option value={index + 1} key={per}>{per}</Option>
            }
        })
        const manOptions = this.state.man && this.state.man.map(per => {
            return <Option value={per.idCode} key={per.idCode}>{per.name}-{per.departmentName}</Option>
        })
        return (
            <div className="finance">
                <Modal
                    className="passModal"
                    title='申请退款'
                    closable={false}
                    visible={this.state.showRefundModal}
                    onOk={this.refundOk.bind(this)}
                    okText='确定'
                    width={400}
                    onCancel={this.refundCancel.bind(this)}
                >
                    <div>
                        <Row className="fs12 b12">
                            退款金额<span className="redPoint">*</span>
                        </Row>
                        <Row className="fs12 b12">
                            <Input placeholder="请输入" value={this.state.tuiAmount} onChange={this.changePopAmountValue.bind(this, 'tuiAmount')} suffix="元" />
                        </Row>
                        <Row className="fs12">
                            退款原因<span className="redPoint">*</span>
                        </Row>
                        <TextArea rows={4} value={this.state.tuiReason} onChange={this.changePopAmountValue.bind(this, 'tuiReason')} placeholder="请输入" style={{ marginTop: '8px' }} />
                    </div>
                </Modal>
                <Modal
                    className="passModal"
                    title='开收据'
                    closable={false}
                    visible={this.state.showReceiptModal}
                    onOk={this.receiptOk.bind(this)}
                    okText='确定'
                    width={400}
                    onCancel={this.receiptCancel.bind(this)}
                >
                    <div>
                        <Row className="fs12 b12">
                            实收金额：{billInfo.paidAmount}元
                    </Row>
                        <Row className="fs12 b12">
                            已开收据金额：{billInfo.receiptAmount}元
                    </Row>
                        <Row className="fs12 b12">
                            待开收据金额：{billInfo.couldReceiptAmount}元
                    </Row>
                        <Row className="fs12 b12">
                            本次收据金额<span className="redPoint">*</span>
                        </Row>
                        <Input placeholder="请输入" value={this.state.popAmount} onChange={this.changePopAmountValue.bind(this, 'popAmount')} />
                    </div>
                </Modal>
                <div className="contract-list">
                    <div className="contract-search">
                        <div className="contract-list-row">
                            <span className='w240'>
                                <Input.Search placeholder="请输入收付款人姓名/手机号/账单关联房间号" onChange={this.setKeyWord}
                                    onSearch={this.keyWordSearch} value={params.keyword} className='w240' />
                            </span>
                            <span className="w104">
                                <ISelect data={this.state.auditStatusList} placeholder="审批状态" value={params.auditStatus}
                                    selectMethod={this.selectChange.bind(this, 'auditStatus')} className="w104" />
                            </span>
                            <span className='w104'>
                                <ISelect data={this.state.bill} placeholder="账单类型" value={params.billType}
                                    selectMethod={this.selectChange.bind(this, 'billType')} className="w104" />
                            </span>
                            <span className='w104'>
                                <ISelect data={this.state.pay} placeholder="收付类型" value={params.budgetType}
                                    selectMethod={this.selectChange.bind(this, 'budgetType')} className="w104" />
                            </span>
                            <span className='w104' style={{ marginRight: '0px' }}>
                                <ISelect
                                    data={this.state.dateType}
                                    className='w104'
                                    value={params.dateType}
                                    placeholder="时间类型"
                                    suffixIcon={<Icon type="caret-down" />}
                                    onSelect={this.choosedateType.bind(this)}>
                                </ISelect>
                            </span>
                            <span className='w206 cx-date-style'>
                                <RangePicker onChange={this.onChangedate.bind(this)} className='w206' value={this.state.dateValue} />
                            </span>
                            <span className='w104'>
                                <Select
                                    disabled={!isManager()}
                                    value={params.auditUserEncode}
                                    onChange={this.selectChange.bind(this, 'auditUserEncode')}
                                    showSearch
                                    allowClear
                                    showArrow={false}
                                    placeholder="审批人"
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    filterOption={false}
                                    onSearch={this.getCustomerList.bind(this)}
                                    notFoundContent='无匹配结果'
                                    className='w104'
                                >
                                    {manOptions}
                                </Select>
                            </span>
                            {/* </Row>
                    <Row gutter={12} style={{ marginBottom: '12px',display:'flex'}}> */}
                            <span className='w288'>
                                <Select dropdownClassName="cx-dropdown-style" mode="multiple" placeholder="项目名称" otFoundContent={fetchingprojects ? this.notFount() : this.notFoundContent()} value={params.projectEncodes} className='w288' onChange={this.selectChange.bind(this, 'projectEncodes')}>
                                    {options}
                                </Select>
                            </span>
                            <span className='w288'>
                                <Select mode="multiple" placeholder="费用类型" value={params.feeTypes} className='w288' onChange={this.selectChange.bind(this, 'feeTypes')}>
                                    {optionsFee}
                                </Select>
                            </span>
                            <span span={3} className="reset" style={{ cursor: 'pointer', fontSize: '12px', textDecoration: 'underline', textUnderlinePosition: 'under', color: '#333' }}>
                                <a onClick={this.resetParams.bind(this)}>重置</a>
                            </span>
                        </div>
                        <Row style={{ 'marginTop': '16px' }}>
                            <span className={`tabClass ${this.state.queryParams.auditFilterType === 0 ? "activeTab" : null}`} onClick={this.changetab.bind(this, 0)}>全部({countData.all})</span>
                            <span className={`tabClass ${this.state.queryParams.auditFilterType === 1 ? "activeTab" : null}`} onClick={this.changetab.bind(this, 1)}>待我审批({countData.toAudit})</span>
                            <span className={`tabClass ${this.state.queryParams.auditFilterType === 2 ? "activeTab" : null}`} onClick={this.changetab.bind(this, 2)}>我已审批({countData.audited})</span>
                            {/* <span className={`tabClass ${this.state.queryParams.auditFilterType===3?"activeTab":null}`} onClick={this.changetab.bind(this,3)}>已结清({countData.allPaid})</span> */}
                        </Row>
                    </div>
                    <div className="contract-table OperateMaintaintable-body">
                        <Table rowKey={record => record.encode} columns={this.state.columns} scroll={{ x: 1300 }} selfProcessData={this.state.data} total={params.total} change={this.onChange} current={params.pageNo} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(FinanceApproval)